<script setup lang="ts">
import { Sheet, SheetContent } from '../sheet';
import FacilityFullDetailsEditor from './FacilityFullDetailsEditor.vue';
import { ref } from 'vue';
import { facilityCreateBlank } from '../../cross-app-shared/services/facilities';
import { you } from '../users';
import type { Facility, FacilityGroupID, SimpleSelectable, TenantID } from '../../cross-app-shared/types/db';

const props = defineProps<{ tenantIDDefault: TenantID; facilityGroupIDDefault: FacilityGroupID }>();

const isOpen = defineModel<boolean>('isOpen', { required: true });

const emit = defineEmits<{ saved: [SimpleSelectable<Facility>] }>();

const facility = ref(facilityCreateBlank(props.tenantIDDefault, props.facilityGroupIDDefault, you.value.userID));

function handleSaved(facilityCreated: SimpleSelectable<Facility>) {
  isOpen.value = false;
  emit('saved', facilityCreated);
  facility.value = facilityCreateBlank(facilityCreated.tenantID, facilityCreated.facilityGroupID, you.value.userID);
}
</script>

<template>
  <Sheet v-model:open="isOpen">
    <SheetContent style="overflow: auto" class="w-full sm:max-w-[1200px]">
      <FacilityFullDetailsEditor
        :readonly="false"
        v-model="facility"
        @saved="handleSaved($event)"
        mode="create"
        :apps="[]"
      />
    </SheetContent>
  </Sheet>
</template>
